import React from 'react';
import { Typography, Box } from '@kohler-dsm-library/kohler-core';
import styles from '../productFeatureCarousel.module.css';

export default function ProductCategories({ categories = [] }) {
  return (
    <Box>
      {categories.map((cat, idx) => (
        <Box key={idx} className={styles.categoryBlock}>
          {cat.title && (
            <Typography size="label-medium-l" className={styles.categoryTitle}>
              {cat.title}
            </Typography>
          )}

          <Box className={styles.categoryProducts}>
            {cat.products.map((prod, i) => (
              <Box key={i} className={styles.productCard}>
                <Box className={styles.productCardImg}>
                  <img src={prod.image} alt={prod.altText} />
                </Box>
                <Typography size="label-regular-m" className={styles.productCardLabel}>
                  {prod.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
